// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"institution-checked"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 7L11 2L20 7V8H2V7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 12V18M5 12V18M11 22H2M17 12V16M2 7V8H20V7L11 2L2 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.1823 17.9395L16.9397 22.1821L14.8184 20.0608","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const InstitutionCheckedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'institution-checked',
    ref,
    icon: element,
  },
));

InstitutionCheckedIcon.displayName = 'InstitutionCheckedIcon';

export default InstitutionCheckedIcon;
